import { Injectable } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { BehaviorSubject, Subject } from 'rxjs';
import { IFeatureVarsResponseMap } from '../../interfaces/feature-vars.interface';
import { IChatBotV2Mensaje, IChatBotV2MensajeDocumento, IChatBotV2Response, IChatBotV2SesionData, IEstadoChatBotV2Response } from '../../models/chat-bot-v2.model';
import { AlertService } from '../alert/alert.service';

@Injectable({
  providedIn: 'root'
})
export class ChatBotV2DataService {

  configVars: IFeatureVarsResponseMap;

  estadoChatBot: IEstadoChatBotV2Response = null;

  tabActive = new BehaviorSubject<number>(0);

  chatForm = new FormGroup({
    pregunta: new FormControl(''),
    documentos: new FormControl([])
  });

  historialChat: IChatBotV2Mensaje[] = [];

  sessionID: string;

  maxFiles = 5;

  sidenav = false;
  selectRow: IChatBotV2SesionData;

  recargarDashboard = new Subject<void>();

  sePuedeSubirDocumentos: boolean = false;

  poseeFiltros: boolean;

  constructor(
    private alertS: AlertService
  ) { }

  obtenerConfiguracionPregunta() {
    return {
      consumerId: this.estadoChatBot.data.consumerId,
      promptId: this.obtenerPrompt(this.estadoChatBot.data.data.prompts),
      temperatura: this.estadoChatBot.data.data.modelParams,
      sessionChat: this.sessionID
    }
  }

  private obtenerPrompt(lista: string[]): string {
    const indiceAleatorio = Math.floor(Math.random() * lista.length);
    return lista[indiceAleatorio];
  }

  /** Elimina la información del chat */
  eliminarChat() {
    this.sessionID = null;
    this.historialChat = [];
    this.chatForm.reset();
  }

  mapResponseHistorial(historialResponse: IChatBotV2Response): IChatBotV2Mensaje[] {
    const historial: IChatBotV2Mensaje[] = [];
    historialResponse.data.historyChat.forEach(chat => {
      const docs = chat.documents?.map(doc => this.mapDoc(doc)) || [];
      if (!docs.length) {
        const docsInQuestion = chat?.question?.match(/\{document\.(\d+)\}/g) || [];
        docsInQuestion?.forEach(() => docs.push({ b64: '', mime_type: '' }));
      }
      historial.push(
        {
          contenidoMensaje: chat.question,
          fechaMensaje: chat.created,
          tipoMensaje: 'SALIENTE',
          documentos: docs
        },
        {
          contenidoMensaje: chat.answer,
          fechaMensaje: chat.created,
          tipoMensaje: 'ENTRANTE',
        },
      );
    });
    return historial;
  }

  private mapDoc(doc: IChatBotV2MensajeDocumento) {
    if (doc?.uri) doc.name = doc.uri?.split('/')?.pop();
    return doc;
  }


  /** Files */

  private getLimitDocuments(documentos: any[] = []) {
    const documentosValidos = documentos.filter(
      (doc): doc is File => doc instanceof File
    );

    const suma = documentosValidos.reduce((acc, file) => acc + file.size, 0);
    const mb = suma / 1e6;

    if (documentosValidos.length > this.maxFiles || mb > 5) {
      this.showAlert(documentosValidos, mb);
      documentosValidos.pop();
      return this.getLimitDocuments(documentosValidos);
    }

    return documentosValidos;
  }


  private showAlert(documentos: any, mb: number) {
    let mensaje = '';
    if (documentos.length > this.maxFiles) {
      mensaje = `La cantidad de los archivos es superior al maximo permitido (${this.maxFiles})`;
    }
    if (mb > 5) {
      mensaje = 'El tamaño del archivo supera los 5mb.';
    }
    this.alertS.showSnackBarTopRight({
      titulo: 'Archivo',
      mensaje,
      severity: 'warning',
    });
  }

  agregarFiles(files: File[]) {
    let documentos: File[] = this.chatForm.value?.documentos ?? [];

    documentos = documentos.concat(files).filter((f): f is File => f instanceof File);

    documentos = this.getLimitDocuments(documentos);

    this.chatForm.patchValue({ documentos });
  }

  eliminarFile(index: number) {
    const documentos: any[] = this.chatForm.value.documentos || [];
    documentos.splice(index, 1);
    this.chatForm.get('documentos').setValue(documentos);
  }

  mapFile(file: File) {
    return new Promise((res) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        res({
          uri: file.name,
          mime_type: file.type,
          b64: String(reader.result).split(',')[1],
          size: file.size
        })
      }
    });
  }

}
